import * as React from "react";

const MiniImageFileIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 17h17v3H4l-4-3Z" fill="#4A148C" />

    <mask id="image-mask" fill="#fff">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.757 0H3a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1V5.243L13.757 0Z"
      />
    </mask>

    {/* Light Gray Paper Base */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.757 0H3a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1V5.243L13.757 0Z"
      fill="#F2F2F2"
    />

    <path
      d="m13.757 0 .707-.707L14.172-1h-.415v1ZM19 5.243h1v-.415l-.293-.292-.707.707ZM3 1h10.757v-2H3v2Zm0 0v-2a2 2 0 0 0-2 2h2Zm0 19V1H1v19h2Zm0 0H1a2 2 0 0 0 2 2v-2Zm15 0H3v2h15v-2Zm0 0v2a2 2 0 0 0 2-2h-2Zm0-14.757V20h2V5.243h-2Zm1.707-.707L14.464-.707 13.05.707l5.243 5.243 1.414-1.414Z"
      fill="#7B1FA2"
      mask="url(#image-mask)"
    />

    <g fill="#7B1FA2">
      <path d="M6.5 3C5.67 3 5 3.67 5 4.5v5c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-7ZM6 4.5C6 4.22 6.22 4 6.5 4h7c.28 0 .5.22.5.5v5c0 .28-.22.5-.5.5h-7A.5.5 0 0 1 6 9.5v-5Z" />
      <circle cx="11.5" cy="5.5" r="1" />
      <path d="M6.5 9.5l2-2.5 1.5 1.5 2-2 2 2.5h-7.5Z" />
    </g>

    <path fill="#7B1FA2" d="M0 12h17v5H0z" />

    <path
      d="M13.5 1 18 5.5h-3c-1 0-1.5-.5-1.5-1.5V1ZM4 13.5h.8v2.4H4v-2.4Zm2 0h.8l.7 1.1.7-1.1h.8v2.4h-.6v-1.6l-.6.9h-.6l-.6-.9v1.6H6v-2.4Zm4.5 1.2c0-.7.5-1.3 1.2-1.3.5 0 1 .2 1.2.6l-.6.4c-.1-.2-.3-.3-.6-.3-.3 0-.6.3-.6.6 0 .4.3.7.6.7v-.4h-.5v-.5h1.1v1.3c-.3.2-.6.3-1 .3-.7 0-1.4-.5-1.4-1.4Z"
      fill="#fff"
    />
  </svg>
);

export default MiniImageFileIcon;
